import React from "react";
import { Icon } from "../core/Icon.jsx";
import { Logo } from "../brand/Logo.jsx";

/* App side navigation. Icon rail (72px) that can expand (248px) to show labels.
   Active item: mint-light pill + green icon. Tokeniser mark/wordmark at top. */
export function SideNav({
  items = [],
  active,
  onSelect,
  expanded = false,
  footer,
  brandSrc,
  brandAlt,
  style,
  ...rest
}) {
  return (
    <nav
      style={{
        display: "flex",
        flexDirection: "column",
        width: expanded ? "var(--sidebar-w-exp)" : "var(--sidebar-w)",
        flex: "none",
        height: "100%",
        background: "var(--white)",
        borderRight: "1px solid var(--divider)",
        padding: "20px 12px",
        gap: 6,
        transition: "width var(--dur-slow) var(--ease)",
        boxSizing: "border-box",
        ...style,
      }}
      {...rest}
    >
      <div
        style={{
          flex: "none",
          height: "calc(var(--space-6) + 70px + var(--space-6))",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          padding: expanded ? "var(--space-6) var(--space-2)" : "var(--space-6) 0",
          justifyContent: expanded ? "flex-start" : "center",
        }}
      >
        {expanded ? (
          <Logo brandSrc={brandSrc} brandAlt={brandAlt} maxWidth={200} maxHeight={70} color="var(--slate)" />
        ) : (
          <Logo
            variant="mark"
            brandSrc={brandSrc}
            brandAlt={brandAlt}
            maxWidth={48}
            maxHeight={36}
            color="var(--green-success)"
          />
        )}
      </div>

      {items.map((it) => (
        <NavItem key={it.id} item={it} active={active === it.id} expanded={expanded} onSelect={onSelect} />
      ))}

      <div style={{ marginTop: "auto", paddingTop: 12 }}>
        {footer}
      </div>
    </nav>
  );
}

function NavItem({ item, active, expanded, onSelect }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      type="button"
      title={item.label}
      onClick={() => onSelect && onSelect(item.id)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        width: "100%",
        height: 44,
        padding: expanded ? "0 12px" : 0,
        justifyContent: expanded ? "flex-start" : "center",
        border: "none",
        borderRadius: "var(--radius-xs)",
        background: active ? "var(--mint-light)" : hover ? "var(--grey-bg)" : "transparent",
        color: active ? "var(--green-success)" : "var(--text-body)",
        cursor: "pointer",
        transition: "background var(--dur) var(--ease), color var(--dur) var(--ease)",
        position: "relative",
      }}
    >
      {active ? (
        <span style={{ position: "absolute", left: 0, top: 11, bottom: 11, width: 3, borderRadius: 3, background: "var(--green-bright)" }} />
      ) : null}
      <Icon name={item.icon} size={22} />
      {expanded ? (
        <span style={{ fontFamily: "var(--font-sans)", fontWeight: active ? 600 : 500, fontSize: 14, whiteSpace: "nowrap" }}>
          {item.label}
        </span>
      ) : null}
      {expanded && item.badge ? (
        <span
          data-testid="nav-badge-dot"
          style={{ marginLeft: "auto", width: 8, height: 8, borderRadius: "50%", background: "var(--green-success)", flex: "none" }}
        />
      ) : null}
    </button>
  );
}

export default SideNav;
